/**
 * activity-kinds.ts — each kind of activity's words (activityTypes.*) and its
 * tone, one table for every screen that names a kind: the shell's
 * ActivityKindPill draws it, and the student's chapter view reads its words
 * beside an accent of its own. A kind the API gains needs both, or the build
 * fails. Four kinds that all looked alike would be worse than no colour at all.
 */

import type { TFunction } from 'i18next';
import type { PillTone } from '../../components/pill';
import type { ActivityKind } from '../../api/_shared/types';

/** Each kind's words, a key written whole, and its tone. */
const ACTIVITY_KIND_LOOK: Record<ActivityKind, { key: string; tone: PillTone }> = {
  ARTICLE: { key: 'activityTypes.ARTICLE', tone: 'article' },
  VIDEO: { key: 'activityTypes.VIDEO', tone: 'video' },
  QUIZ: { key: 'activityTypes.QUIZ', tone: 'quiz' },
  GAMEPLAY: { key: 'activityTypes.GAMEPLAY', tone: 'gameplay' },
};

/**
 * A kind's words and tone, read the one way by every screen: a kind off the
 * wire the table does not know reads as itself, in neutral, so a kind the API
 * gains renders before the table has it rather than throwing where its words
 * are read.
 */
export function activityKindLook(kind: string, t: TFunction): { words: string; tone: PillTone } {
  const look = (ACTIVITY_KIND_LOOK as Partial<Record<string, { key: string; tone: PillTone }>>)[kind];
  return look ? { words: t(look.key), tone: look.tone } : { words: kind, tone: 'neutral' };
}
